import * as Yup from 'yup';
import * as R from './rules';

export const validationSchema = Yup.object({
  name: Yup.string().required('نام الزامی است'),
  display_name: Yup.string().required('نام نمایشی الزامی است'),
  // These were bare `^\d+$` numeric checks, which passed any length and left
  // the api to reject the value after a round trip.
  national_id: Yup.string()
    .required('کد ملی الزامی است')
    .matches(R.NATIONAL_ID, R.NATIONAL_ID_MESSAGE),
  address: Yup.string().required('آدرس الزامی است'),
  postal_code: Yup.string()
    .required('کد پستی الزامی است')
    .matches(R.POSTAL_CODE, R.POSTAL_CODE_MESSAGE),
  phone: Yup.string()
    .required('تلفن ثابت الزامی است')
    .matches(R.LANDLINE_PHONE, R.LANDLINE_PHONE_MESSAGE),
});
